import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";

import { AuthProvider } from "react-auth-kit";

ReactDOM.render(
  <AuthProvider authType="cookie" authName="_auth" cookieDomain={window.location.hostname}>
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <App />
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </AuthProvider>,
  document.getElementById("root")
);
